import { CSSProperties, MouseEventHandler } from 'react';
import LogoDatafy from '../../img/Logo-Datafy.svg';
import arrowLeftMenu from '../../img/arrowLeftMenu.png';
import pageNotFound from '../../img/pageNotFound.svg';
import LogoANID from '../../img/LogoANID.svg';
import LogoACESOL from '../../img/LogoACESOL.svg';
import LogoFICUAI from '../../img/LogoFICUAI.svg';
import LogoVisionDERRED from '../../img/LogoVisionDERRED.svg';
import noImg from '../../img/noImg.svg';
import myAccountIcon from '../../img/myAccountIcon.svg';
import listIcon from '../../img/listIcon.svg';
import arrowRightIcon from '../../img/arrowRightIcon.svg';
import signOutIcon from '../../img/signOutIcon.svg';
import userIconBlack from '../../img/userIconBlack.svg';
import userIconWhite from '../../img/userIconWhite.svg';
import LogoVisionDERREDWhite from '../../img/LogoVisionDERREDWhite.svg';
import doubleArrowLeftIcon from '../../img/doubleArrowLeftIcon.svg';
import gearSixIcon from '../../img/gearSixIcon.svg';
import clipboardListIcon from '../../img/clipboardListIcon.svg';
import mapMarkedSolidIcon from '../../img/mapMarkedSolidIcon.svg';
import databaseSolidIcon from '../../img/databaseSolidIcon.svg';
import chartBarSolidIcon from '../../img/chartBarSolidIcon.svg';
import chalkboardIcon from '../../img/chalkboardIcon.svg';
import chartBarSolidLargeIcon from '../../img/chartBarSolidLargeIcon.svg';
import clipboardListSolidLargeIcon from '../../img/clipboardListSolidLargeIcon.svg';
import databaseSolidLargeIcon from '../../img/databaseSolidLargeIcon.svg';
import LightbulbFilamentIcon from '../../img/LightbulbFilamentIcon.svg';
import LightningIcon from '../../img/LightningIcon.svg';
import mapMarkedSolidLargeIcon from '../../img/mapMarkedSolidLargeIcon.svg';
import homeWhatWeDo1 from '../../img/home-what-we-do-1.png';
import homeWhatWeDo2 from '../../img/home-what-we-do-2.png';
import homeWhatWeDo3 from '../../img/home-what-we-do-3.png';
import homeWhatWeDo4 from '../../img/home-what-we-do-4.png';
import homeWhatWeDo5 from '../../img/home-what-we-do-5.png';
import homeWhatWeDo6 from '../../img/home-what-we-do-6.png';
import chevronDownIcon from '../../img/chevronDownIcon.svg';
import chevronDownIconWhite from '../../img/chevronDownIconWhite.svg';
import InfoIcon from '../../img/InfoIcon.svg';
import whatWeDo4 from '../../img/what-we-do-4.png';
import errorIcon from '../../img/errorIcon.svg';
import visibilityIcon from '../../img/visibilityIcon.svg';
import visibilityOffIcon from '../../img/visibilityOffIcon.svg';
import closeIcon from '../../img/closeIcon.svg';
import plusCircleWhiteIcon from '../../img/plusCircleWhiteIcon.svg';
import plusCircleBlueIcon from '../../img/plusCircleBlueIcon.svg';
import searchIcon from '../../img/searchIcon.svg';
import gearIcon from '../../img/gearIcon.svg';
import locationIcon from '../../img/locationIcon.svg';
import clipboardWhiteIcon from '../../img/clipboardWhiteIcon.svg';
import plusWhiteIcon from '../../img/plusWhiteIcon.svg';
import filePdfIcon from '../../img/filePdfIcon.svg';
import filePdfIconBlue from '../../img/filePdfIconBlue.svg';
import filePdfGreyIcon from '../../img/filePdfGreyIcon.svg';
import homeImg from '../../img/home.png';
import result1 from '../../img/result_1.png';
import result2 from '../../img/result_2.png';
import result3 from '../../img/result_3.png';
import result4 from '../../img/result_4.png';
import alimentador from '../../img/alimentador.svg';
import transformador from '../../img/transformador.svg';
import subestacion from '../../img/subestacion.svg';
import linea from '../../img/linea.svg';
import pmgd from '../../img/pmgd.svg';
import consumo from '../../img/consumo.svg';
import techoFv from '../../img/techo-fv.svg';
import gd from '../../img/gd.svg';
import poste from '../../img/poste.svg';
import equipoOperacionControl from '../../img/equipo-operacion-control.svg';
import menuIcon from '../../img/menuIcon.svg';
import menuIconWhite from '../../img/menuIconWhite.svg';
import interactiveMap from '../../img/interactive-map.png';
import networkDataManagementDiagram from '../../img/networkDataManagementDiagram.png';
import powerProfileComparison from '../../img/powerProfileComparison.png';
import VoltageProfilePerConsumer from '../../img/VoltageProfilePerConsumer.png';
import connection_evaluation from '../../img/connection_evaluation.png';
import capacityIdentificationAlgorithm from '../../img/capacityIdentificationAlgorithm.png';
import HeatmapResulting from '../../img/HeatmapResulting.png';
import montecarloMetodology from '../../img/montecarloMetodology.png';
import comparacionPerfilTension from '../../img/comparacionPerfilTension.png';
import porcentajeCargasResidenciales from '../../img/porcentajeCargasResidenciales.png';
import companiesLogos from '../../img/companiesLogos.png';
import eyeIdeaIcon from '../../img/eyeIdeaIcon.svg';
import businessDealHandshakeCircleIcon from '../../img/businessDealHandshakeCircleIcon.svg';
import loveIiHandGiveIcon from '../../img/loveIiHandGiveIcon.svg';
import multipleUsersIcon from '../../img/multipleUsersIcon.svg';
import rankingRibbonIcon from '../../img/rankingRibbonIcon.svg';
import readGlassesIcon from '../../img/readGlassesIcon.svg';
import teamIdeaIcon from '../../img/teamIdeaIcon.svg';
import luisGutierrez from '../../img/luisGutierrez.jpg';
import danielOlivares from '../../img/danielOlivares.jpg';
import bernardoSeverino from '../../img/bernardoSeverino.png';
import joseCruz from '../../img/joseCruz.png';
import ignacioPerez from '../../img/ignacioPerez.jpg';
import luisNilo from '../../img/luisNilo.jpg';
import conference from '../../img/conference.jpg';

type Props = {
  icon: string;
  imageStyle?: CSSProperties;
  className?: string;
  onClick?: MouseEventHandler<HTMLImageElement>;
};

const GenericIcons = (props: Props) => {
  const { icon, imageStyle } = props;

  const iconData: {
    icon: string;
    svg: string;
  }[] = [
    {
      icon: 'LogoDatafy',
      svg: LogoDatafy
    },
    {
      icon: 'arrowLeftMenu',
      svg: arrowLeftMenu
    },
    {
      icon: 'pageNotFound',
      svg: pageNotFound
    },
    {
      icon: 'LogoANID',
      svg: LogoANID
    },
    {
      icon: 'LogoACESOL',
      svg: LogoACESOL
    },
    {
      icon: 'LogoFICUAI',
      svg: LogoFICUAI
    },
    {
      icon: 'LogoVisionDERRED',
      svg: LogoVisionDERRED
    },
    {
      icon: 'noImg',
      svg: noImg
    },
    {
      icon: 'myAccountIcon',
      svg: myAccountIcon
    },
    {
      icon: 'listIcon',
      svg: listIcon
    },
    {
      icon: 'arrowRightIcon',
      svg: arrowRightIcon
    },
    {
      icon: 'signOutIcon',
      svg: signOutIcon
    },
    {
      icon: 'userIconBlack',
      svg: userIconBlack
    },
    {
      icon: 'userIconWhite',
      svg: userIconWhite
    },
    {
      icon: 'doubleArrowLeftIcon',
      svg: doubleArrowLeftIcon
    },
    {
      icon: 'LogoVisionDERREDWhite',
      svg: LogoVisionDERREDWhite
    },
    {
      icon: 'gearSixIcon',
      svg: gearSixIcon
    },
    {
      icon: 'clipboardListIcon',
      svg: clipboardListIcon
    },
    {
      icon: 'mapMarkedSolidIcon',
      svg: mapMarkedSolidIcon
    },
    {
      icon: 'databaseSolidIcon',
      svg: databaseSolidIcon
    },
    {
      icon: 'chartBarSolidIcon',
      svg: chartBarSolidIcon
    },
    {
      icon: 'chalkboardIcon',
      svg: chalkboardIcon
    },
    {
      icon: 'chartBarSolidLargeIcon',
      svg: chartBarSolidLargeIcon
    },
    {
      icon: 'clipboardListSolidLargeIcon',
      svg: clipboardListSolidLargeIcon
    },
    {
      icon: 'databaseSolidLargeIcon',
      svg: databaseSolidLargeIcon
    },
    {
      icon: 'LightbulbFilamentIcon',
      svg: LightbulbFilamentIcon
    },
    {
      icon: 'LightningIcon',
      svg: LightningIcon
    },
    {
      icon: 'mapMarkedSolidLargeIcon',
      svg: mapMarkedSolidLargeIcon
    },
    {
      icon: 'home-what-we-do-1',
      svg: homeWhatWeDo1
    },
    {
      icon: 'home-what-we-do-2',
      svg: homeWhatWeDo2
    },
    {
      icon: 'home-what-we-do-3',
      svg: homeWhatWeDo3
    },
    {
      icon: 'home-what-we-do-4',
      svg: homeWhatWeDo4
    },
    {
      icon: 'home-what-we-do-5',
      svg: homeWhatWeDo5
    },
    {
      icon: 'home-what-we-do-6',
      svg: homeWhatWeDo6
    },
    {
      icon: 'chevronDownIcon',
      svg: chevronDownIcon
    },
    {
      icon: 'chevronDownIconWhite',
      svg: chevronDownIconWhite
    },
    {
      icon: 'InfoIcon',
      svg: InfoIcon
    },
    {
      icon: 'result1',
      svg: result1
    },
    {
      icon: 'result2',
      svg: result2
    },
    {
      icon: 'result3',
      svg: result3
    },
    {
      icon: 'result4',
      svg: result4
    },
    {
      icon: 'what-we-do-4',
      svg: whatWeDo4
    },
    {
      icon: 'errorIcon',
      svg: errorIcon
    },
    {
      icon: 'visibilityIcon',
      svg: visibilityIcon
    },
    {
      icon: 'visibilityOffIcon',
      svg: visibilityOffIcon
    },
    {
      icon: 'closeIcon',
      svg: closeIcon
    },
    {
      icon: 'plusCircleWhiteIcon',
      svg: plusCircleWhiteIcon
    },
    {
      icon: 'plusCircleBlueIcon',
      svg: plusCircleBlueIcon
    },
    {
      icon: 'searchIcon',
      svg: searchIcon
    },
    {
      icon: 'gearIcon',
      svg: gearIcon
    },
    {
      icon: 'locationIcon',
      svg: locationIcon
    },
    {
      icon: 'clipboardWhiteIcon',
      svg: clipboardWhiteIcon
    },
    {
      icon: 'plusWhiteIcon',
      svg: plusWhiteIcon
    },
    {
      icon: 'filePdfIcon',
      svg: filePdfIcon
    },
    {
      icon: 'filePdfIconBlue',
      svg: filePdfIconBlue
    },
    {
      icon: 'filePdfGreyIcon',
      svg: filePdfGreyIcon
    },
    {
      icon: 'homeImg',
      svg: homeImg
    },
    {
      icon: 'alimentador',
      svg: alimentador
    },
    {
      icon: 'transformador',
      svg: transformador
    },
    {
      icon: 'subestacion',
      svg: subestacion
    },
    {
      icon: 'linea',
      svg: linea
    },
    {
      icon: 'pmgd',
      svg: pmgd
    },
    {
      icon: 'consumo',
      svg: consumo
    },
    {
      icon: 'techoFv',
      svg: techoFv
    },
    {
      icon: 'gd',
      svg: gd
    },
    {
      icon: 'poste',
      svg: poste
    },
    {
      icon: 'equipoOperacionControl',
      svg: equipoOperacionControl
    },
    {
      icon: 'menuIcon',
      svg: menuIcon
    },
    {
      icon: 'menuIconWhite',
      svg: menuIconWhite
    },
    {
      icon: 'interactiveMap',
      svg: interactiveMap
    },
    {
      icon: 'networkDataManagementDiagram',
      svg: networkDataManagementDiagram
    },
    {
      icon: 'powerProfileComparison',
      svg: powerProfileComparison
    },
    {
      icon: 'VoltageProfilePerConsumer',
      svg: VoltageProfilePerConsumer
    },
    {
      icon: 'connection_evaluation',
      svg: connection_evaluation
    },
    {
      icon: 'capacityIdentificationAlgorithm',
      svg: capacityIdentificationAlgorithm
    },
    {
      icon: 'HeatmapResulting',
      svg: HeatmapResulting
    },
    {
      icon: 'montecarloMetodology',
      svg: montecarloMetodology
    },
    {
      icon: 'comparacionPerfilTension',
      svg: comparacionPerfilTension
    },
    {
      icon: 'porcentajeCargasResidenciales',
      svg: porcentajeCargasResidenciales
    },
    {
      icon: 'companiesLogos',
      svg: companiesLogos
    },
    {
      icon: 'eyeIdeaIcon',
      svg: eyeIdeaIcon
    },
    {
      icon: 'businessDealHandshakeCircleIcon',
      svg: businessDealHandshakeCircleIcon
    },
    {
      icon: 'loveIiHandGiveIcon',
      svg: loveIiHandGiveIcon
    },
    {
      icon: 'multipleUsersIcon',
      svg: multipleUsersIcon
    },
    {
      icon: 'rankingRibbonIcon',
      svg: rankingRibbonIcon
    },
    {
      icon: 'readGlassesIcon',
      svg: readGlassesIcon
    },
    {
      icon: 'teamIdeaIcon',
      svg: teamIdeaIcon
    },
    {
      icon: 'luisGutierrez',
      svg: luisGutierrez
    },
    {
      icon: 'danielOlivares',
      svg: danielOlivares
    },
    {
      icon: 'bernardoSeverino',
      svg: bernardoSeverino
    },
    {
      icon: 'joseCruz',
      svg: joseCruz
    },
    {
      icon: 'ignacioPerez',
      svg: ignacioPerez
    },
    {
      icon: 'luisNilo',
      svg: luisNilo
    },
    {
      icon: 'conference',
      svg: conference
    }
  ];

  const findIcon = (icon_: string) => {
    const icon = iconData.find((p) => p.icon === icon_);

    return icon ? icon?.svg : null;
  };

  const SVGIcon = icon ? findIcon(icon) : null;

  return SVGIcon ? (
    <img
      onClick={props.onClick}
      className={props.className}
      src={SVGIcon}
      alt=''
      style={{ ...imageStyle }}
    />
  ) : null;
};

export default GenericIcons;
